import { createFileRoute } from "@tanstack/react-router";

import { AuthedChrome } from "@/components/app-shell/authed-chrome";

// The chrome layout: every authed *page* lives under this pathless subtree
// and renders inside the persistent header (#152) — membership is the
// mechanism, the same way the _authed gate above decides protection, so
// there is no per-page opt-in to forget. A new domain slice's routes belong
// under _chrome/.
//
// Exactly one authed route stays outside: the catch-all (`../$.tsx`). The 404
// is a chrome-less page (#132 "Chrome and layout"), and a notFound renders at
// the route that raised it — keeping the catch-all off this subtree is what
// keeps the header off the 404 while its own `head` (the "Page not found"
// title) still applies. Pinned by the routed test in
// `../routed-not-found.unit.test.ts`.
export const Route = createFileRoute("/_authed/_chrome")({
  // The donor's AdminLayout glides the window to the top on every change of
  // path; its public pages and its 404 sit outside it (@/lib/router-scroll).
  staticData: { glidesWindowToTop: true },
  component: AuthedChrome,
});
